import React, { useState } from 'react';

const plans = [
    {
        name: 'Essential',
        badge: 'Standard',
        monthlyPrice: 80,
        description: 'Perfect for small teams and startups.',
        features: ['20 Projects', '100k Characters/mo', '1 App Integration', 'Email Support'],
        highlight: false,
        themeBorder: 'linear-gradient(135deg, #d0f0fd 0%, #a0d9ff 100%)',
        themeColor: '#1976d2', // MUI primary roughly
        hoverColor: '#115293',
        ctaName: 'Get Started'
    },
    {
        name: 'Growth',
        badge: 'Popular',
        monthlyPrice: 250,
        description: 'For growing companies with global reach.',
        features: ['200 Projects', '1M Characters/mo', '5 App Integrations', 'Priority Support'],
        highlight: true,
        themeBorder: 'linear-gradient(135deg, #e0ffe1 0%, #b3ffb5 100%)',
        themeColor: '#2e7d32', // MUI success roughly
        hoverColor: '#1b5e20',
        ctaName: 'Upgrade Now'
    },
    {
        name: 'Scale',
        badge: 'Advanced',
        monthlyPrice: 500,
        description: 'Advanced features for large scale operations.',
        features: ['Unlimited Projects', 'Unlimited Characters', 'Unlimited Apps', 'Dedicated Support'],
        highlight: false,
        themeBorder: 'linear-gradient(135deg, #f3e1ff 0%, #dab6ff 100%)',
        themeColor: '#9c27b0', // MUI secondary roughly
        hoverColor: '#7b1fa2',
        ctaName: 'Contact Sales'
    },
];

const Demo6Price = ({ isAuthenticated, onRegister, onDashboard }) => {
    const [isYearly, setIsYearly] = useState(false);

    const handlePlanClick = (planName) => {
        if (isAuthenticated) {
            onDashboard();
        } else {
            onRegister();
        }
    };

    return (
        <section id="pricing" className="bg-whitesmoke-gradient wide-60 pricing-section division" style={{ backgroundColor: '#F8F9FA' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="section-title title-01 mb-80 text-center">
                            <h2 className="h2-md" style={{ fontWeight: 600, color: '#1B1B1B' }}>Choose Your Plan</h2>
                            <p className="p-xl" style={{ color: '#6C757D' }}>Choose the right program for your business</p>
                        </div>
                    </div>
                </div>

                {/* Monthly / Yearly Toggle */}
                <div className="row justify-content-center mb-5">
                    <div className="col-auto">
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '30px',
                            padding: '5px',
                            boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.05)',
                        }}>
                            <button
                                onClick={() => setIsYearly(false)}
                                style={{
                                    border: 'none',
                                    backgroundColor: !isYearly ? '#1B1B1B' : 'transparent',
                                    color: !isYearly ? '#FFFFFF' : '#6C757D',
                                    borderRadius: '25px',
                                    padding: '8px 24px',
                                    fontWeight: 600,
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                }}
                            >
                                Monthly
                            </button>
                            <button
                                onClick={() => setIsYearly(true)}
                                style={{
                                    border: 'none',
                                    backgroundColor: isYearly ? '#1B1B1B' : 'transparent',
                                    color: isYearly ? '#FFFFFF' : '#6C757D',
                                    borderRadius: '25px',
                                    padding: '8px 24px',
                                    fontWeight: 600,
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                }}
                            >
                                Yearly
                            </button>
                        </div>
                    </div>
                </div>

                <div className="pricing-2-row pc-25">
                    <div className="row justify-content-center" style={{ gap: '20px' }}>
                        {plans.map((plan, index) => {
                            const price = isYearly ? Math.floor(plan.monthlyPrice * 0.9 * 12) : plan.monthlyPrice;
                            const period = isYearly ? '/ Year' : '/ Month';

                            return (
                                <div className="col-md-4" key={plan.name} style={{ maxWidth: '350px' }}>
                                    <div
                                        className="pricing-2-table wow fadeInUp"
                                        style={{
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '15px',
                                            padding: '40px 30px',
                                            boxShadow: plan.highlight ? '0px 10px 40px rgba(0, 0, 0, 0.08)' : '0px 4px 20px rgba(0, 0, 0, 0.04)',
                                            position: 'relative',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            height: '100%',
                                        }}
                                    >
                                        {/* Custom Gradient Top Border */}
                                        <div style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            height: '6px',
                                            background: plan.themeBorder,
                                            borderTopLeftRadius: '15px',
                                            borderTopRightRadius: '15px'
                                        }} />

                                        <div className="pricing-plan text-center mb-3">
                                            <h5 style={{ fontWeight: 600, color: '#1B1B1B', marginBottom: '15px', marginTop: '10px' }}>{plan.name}</h5>

                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', marginBottom: '10px' }}>
                                                <sup style={{ fontSize: '24px', fontWeight: 600, color: plan.themeColor, top: '-15px' }}>£</sup>
                                                <span style={{ fontSize: '48px', fontWeight: 700, color: plan.themeColor }}>{price}</span>
                                                <span style={{ fontSize: '14px', color: '#6C757D', marginLeft: '5px' }}>{period}</span>
                                            </div>

                                            <p style={{ color: '#6C757D', fontSize: '14px', marginBottom: '10px' }}>{plan.description}</p>

                                            <button
                                                style={{
                                                    background: 'transparent',
                                                    border: `1px solid ${plan.themeColor}`,
                                                    borderRadius: '4px',
                                                    color: plan.themeColor,
                                                    padding: '4px 12px',
                                                    fontSize: '13px',
                                                    cursor: 'pointer',
                                                    marginBottom: '20px',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.backgroundColor = plan.themeColor;
                                                    e.currentTarget.style.color = '#FFFFFF';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                    e.currentTarget.style.color = plan.themeColor;
                                                }}
                                                onClick={() => handlePlanClick(plan.name)}
                                            >
                                                Try for free
                                            </button>
                                        </div>

                                        {/* Divider */}
                                        <div style={{ height: '1px', backgroundColor: '#E9ECEF', width: '100%', marginBottom: '25px' }} />

                                        <ul className="features mb-5" style={{ listStyle: 'none', padding: 0, flexGrow: 1 }}>
                                            {plan.features.map((feature, i) => (
                                                <li key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                    <svg
                                                        width="16"
                                                        height="16"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke={plan.themeColor}
                                                        strokeWidth="3"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        style={{ marginRight: '10px', minWidth: '16px' }}
                                                    >
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                    <span style={{ color: '#495057', fontSize: '14px' }}>{feature}</span>
                                                </li>
                                            ))}
                                        </ul>

                                        <div className="text-center mt-auto" style={{ position: 'relative' }}>
                                            {plan.highlight && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '-45px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    backgroundColor: plan.themeColor,
                                                    color: '#FFFFFF',
                                                    padding: '4px 15px',
                                                    borderRadius: '20px',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    Most Popular
                                                </div>
                                            )}
                                            <button
                                                className="btn"
                                                onClick={() => handlePlanClick(plan.name)}
                                                style={{
                                                    width: '100%',
                                                    padding: '12px',
                                                    borderRadius: '8px',
                                                    border: plan.highlight ? 'none' : `1px solid ${plan.themeColor}`,
                                                    backgroundColor: plan.highlight ? plan.themeColor : 'transparent',
                                                    color: plan.highlight ? '#FFFFFF' : plan.themeColor,
                                                    fontWeight: 600,
                                                    transition: 'all 0.3s ease',
                                                }}
                                                onMouseOver={(e) => {
                                                    e.currentTarget.style.backgroundColor = plan.highlight ? plan.hoverColor : plan.themeColor;
                                                    e.currentTarget.style.color = '#FFFFFF';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.currentTarget.style.backgroundColor = plan.highlight ? plan.themeColor : 'transparent';
                                                    e.currentTarget.style.color = plan.highlight ? '#FFFFFF' : plan.themeColor;
                                                }}
                                            >
                                                {plan.ctaName}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="payment-methods pc-30 mt-80">
                    {/* Kept payment methods section */}
                    <div className="row row-cols-1 row-cols-md-3">
                        <div className="col col-lg-5">
                            <div className="pbox mb-40">
                                <h6 className="h6-md">Accepted Payment Methods</h6>
                                <ul className="payment-icons ico-50">
                                    {['visa', 'am', 'discover', 'paypal', 'jcb', 'shopify'].map((icon) => (
                                        <li key={icon}>
                                            <img src={`/images/demo6/png-icons/${icon}.png`} alt="payment-icon" />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-4">
                            <div className="pbox mb-40">
                                <h6 className="h6-md">Money Back Guarantee</h6>
                                <p>Try Rush Studio risk-free for 14 days. If it’s not a perfect fit, receive a full refund.</p>
                            </div>
                        </div>
                        <div className="col col-lg-3">
                            <div className="pbox mb-40">
                                <h6 className="h6-md">SSL Encrypted Payment</h6>
                                <p>Your information is protected by 256-bit SSL encryption.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Price;

